/** @format */

export const DB_SEED: string = 'seed';
